export default {
	articleEditDialog: {
		title: "Article {articleId} - Settings",
		articleNameLabel: "Article name",
		articleNumberLabel: "Article number",
		articleNumberPlaceholder: "Your article number",
		articleNumberHint:
			"You can assign your own article number to each article. The number also appears on the delivery note and the invoice.",
		materialLabel: "Material",
		deburringLabel: "Deburring:",
		migratedHint: "Blexonise the article to change the deburring.",
		deburringPlaceholder: "Please select deburring type...",
		werkstoffChangedHint:
			"If the material is to be changed, the article must first be recalculated before the deburring type can be adjusted. To do this, save the current changes and wait until the article has been validated.",
		deburringInfoTooltip: "Information about deburring metal parts",
		close: "Close",
		saveMaterialTooltip: "Saves the material.",
		saveArticleTooltip: "Saves the article with the specified data.",
		saveFailedError: "The data could not be saved. {error}",
		saveMaterialFailedError: "The material could not be changed. {error}",
	},
	articleDeleteWarningDialog: {
		title: "Warning!",
		inCartsText: "The article will also be deleted from the following parts lists:",
		confirmDelete: "Do you really want to delete this article?",
		weldedText:
			"This article cannot be deleted because it is welded to other articles in this assembly.",
		delete: "Delete",
		messages: {
			deleteError: "The article could not be deleted.",
		},
	},
	articleMultiDeleteDialog: {
		title: "Delete multiple articles",
		deletedProgress: "{deleted} of {total} deleted",
		lockedArticlesText:
			"The following articles are either locked or currently being calculated, and can therefore {not} be deleted:",
		lockedArticlesTextBold: "not",
		partOfCartsText: "The following articles are part of at least one parts list:",
		containedIn: "Contained in...",
		confirmDeleteCount: "Do you really want to delete {count} articles?",
		noneCanBeDeleted: "None of the selected articles can be deleted.",
		delete: "Delete",
		messages: {
			deleteError: "Error deleting an article.",
		},
	},
	articlePriceInfoDialog: {
		title: "You can see the final price, including volume discount, in the shopping cart.",
		intro:
			"The price list helps designers to quickly estimate prices and applies to ordering this single article (uniform batch).",
		explanation:
			"To calculate the final price, please put together a shopping cart and have a quote, including delivery date, calculated within seconds.",
		discountExplanation:
			"When calculating the quote, all included articles are taken into account and an order-specific discount (order discount) is calculated.",
		discountHighlight:
			"Multiple articles with the same processing or the same material lead to a price reduction.",
		factorsIntro: "The following factors lead to a {reduction}",
		factorsReductionBold: "price reduction:",
		factor1: "Multiple articles made from the same raw material (same material and same sheet thickness)",
		factor2:
			"Multiple articles with the same machining operations (threads, countersinks and extrusions) in the same raw material",
		factor3: "Multiple articles with the same powder coating (same powder)",
		factor4: "Multiple articles with the same galvanising",
		priceNote:
			"The price is exclusive of VAT/sales tax, order-specific discounts, packaging and delivery.",
		close: "Close",
	},
	articleTreatmentEditDialog: {
		closeTooltip: "Closes the dialog.",
		notAvailableTitle: "Powder coating",
		notAvailableText: "Powder coating of articles is unfortunately not yet available in your region.",
		titleSingle: "Powder coating - Article '{name}' ({id})",
		titleMultiple: "Powder coating - {count} articles",
		standardColorsHint: "Only standard colours without surcharge are shown.",
		showAllColorsLabel: "Show all colours",
		ralSearchLabel: "Search RAL colour",
		structureLabel: "Structure",
		finishLabel: "Finish",
		powderSelectionHeading: "Powder selection:",
		standardNoSurchargeSuffix: " (Standard without surcharge)",
		noPowderAvailable: "No powders available with the current filter",
		nonStandardPowderInfo1: "This powder is not part of the standard range and must be ordered.",
		nonStandardPowderInfo2:
			"A one-time surcharge of {cost} will be applied. If there are multiple positions in this colour, the surcharge is only charged once, as it is taken into account in the order discount.",
		nonStandardPowderInfo3:
			"Please note that this may also result in longer delivery times.",
		faceLabel: "Surface",
		baseCoatingLabel: "Pre-priming: provides corrosion protection",
		warningText1:
			"When powder coating, a {thickness} must be expected. Design any holes and cutouts accordingly larger. {gewinde} are covered before coating and do not need to be adjusted. {senkungen} are not covered, but the coating thickness is compensated for during production.",
		warningThicknessBold: "coating thickness of approx. 0.1mm",
		warningGewindeBold: "Threads",
		warningSenkungenBold: "Countersinks",
		warningTextOneSided:
			"Furthermore, it must be taken into account that with one-sided coating, the opposite side is not covered, and therefore a {spray} must be expected on that side.",
		warningSprayBold: "spray mist",
		warningText2:
			"{achtung} Powder coating alone provides {noCorrosion}. Powder-coated {steelParts} are therefore {notOutdoor}, unless a {primer} treatment is applied. This is an additional coating that provides corrosion protection for steel parts. Powder-coated parts made of stainless steel or aluminium are suitable for outdoor use or locations with high humidity, provided there are no extreme environmental conditions. In extreme weather conditions and in environments with high humidity and high salt content in the air, pre-priming should also be chosen for aluminium. If you have any questions or uncertainties, please feel free to contact our helpdesk.",
		warningAchtungBold: "Attention:",
		warningNoCorrosionBold: "no corrosion protection",
		warningSteelPartsBold: "steel parts",
		warningNotOutdoorBold: "not suitable for outdoor use or locations with high humidity",
		warningPrimerBold: "pre-priming",
		close: "Close",
		removeTooltipSingle: "Removes the powder coating from the article.",
		removeTooltipMultiple: "Removes the powder coating from all articles.",
		removeButton: "Remove",
		saveTooltipSingle: "Saves the powder coating.",
		saveTooltipMultiple: "Saves the powder coating for all articles.",
		finishOptions: {
			all: "All",
			matt: "Matt",
			glossy: "Gloss",
		},
		structureOptions: {
			all: "All",
			smooth: "Smooth",
			fine: "Fine",
			rough: "Rough",
		},
		faceOptions: {
			top: "Top side",
			bottom: "Bottom side",
			both: "Both sides",
		},
		messages: {
			loadPowdersError: "The powders could not be loaded.",
			loadMaterialIdsError: "The material IDs could not be loaded.",
			saveError: "The surface treatment of article {articleId} could not be saved.",
			saveSuccess: "The surface treatment has been saved.",
			deleteError: "The surface treatment of article {articleId} could not be deleted.",
			deleteSuccess: "The surface treatment has been deleted.",
		},
	},
	articleZincCoatingEditDialog: {
		analyzingTitle: "Analysing galvanising...",
		close: "Close",
		titleSingle: "Galvanising - Article '{name}' ({id})",
		titleMultiple: "Galvanising - {count} articles",
		errorIntroSingle: "Galvanising is not possible for this article for the following reason:",
		errorIntroMultiple: "Galvanising is not possible for the listed articles:",
		hotDipLabel: "Hot-dip galvanising",
		thicknessLabel: "Coating thickness: ",
		hotDipThicknessValue: "50-150µm",
		galvanizeThicknessValue: "5-20µm",
		moreInfo: "More information",
		hotDipInfoText:
			"During hot-dip galvanising, the components are dipped into a zinc bath at a temperature of around 450 °C. This high temperature creates stresses in the components. A suitable design of the parts to be galvanised is therefore very important. For closed components (e.g. welded boxes), openings must be provided. These allow the air, which expands when heated, to escape on one hand, and the excess zinc to drain off when withdrawn from the melt on the other. In addition, thin sheets (thickness < 4mm) are usually not suitable for hot-dip galvanising, as they can warp significantly under the effect of heat.",
		hotDipNotPossibleSingle: "Hot-dip galvanising is not available for this material.",
		assemblyHint:
			"Assemblies can only be galvanised if all sub-articles allow this type of galvanising.",
		hotDipNotPossibleMultiple:
			"Hot-dip galvanising is not available for this combination of materials. Try galvanising the articles individually.",
		hotDipPowderCoatedConflict:
			"Blexon does not currently offer the combination of hot-dip galvanising and powder coating.",
		threadsNotHotDippable: "Articles with threads or extrusions cannot be hot-dip galvanised.",
		galvanizeLabel: "Electro-galvanising",
		galvanizeInfoText:
			"Unlike hot-dip galvanising, in electro-galvanising the components are not dipped into a molten zinc bath but into a zinc electrolyte. A zinc element acts as the anode and the steel part to be coated as the cathode. This process generates less heat and is therefore suitable for thinner sheets. However, for permanent outdoor use, the thickness of the zinc layer is often too thin.",
		galvanizeNotPossibleSingle: "Electro-galvanising is not available for this material.",
		galvanizeNotPossibleMultiple:
			"Electro-galvanising is not available for this combination of materials. Try galvanising the articles individually.",
		sendToHelpdesk: "Send to helpdesk",
		removeTooltipSingle: "Removes the galvanising from the article.",
		removeTooltipMultiple: "Removes the galvanising from all articles.",
		removeButton: "Remove",
		saveTooltipSingle: "Saves the galvanising.",
		saveTooltipMultiple: "Saves the galvanising for all articles.",
		messages: {
			loadError: "The galvanising data could not be loaded.",
			saveError: "The galvanising of article {articleId} could not be saved.",
			saveSuccess: "The galvanising has been saved.",
		},
	},
	certificateHelperDialog: {
		title: "Certificate / Certifications",
		text1:
			"After delivery of the parts, you can download an inspection certificate 3.1 according to EN 10204:2004 from your order archive.",
		text2: "The certificate comes from the raw material manufacturer and does not include a re-certification confirmation by the sheet metal processor.",
		close: "Close",
	},
	isPowdercoatingPossibleDialog: {
		analyzingTitle: "Analysing powder coating...",
		notPossibleTitle: "Powder coating not selectable",
		possibleTitle: "Powder coating possible",
		reasonIntroSingle: "Powder coating is not possible for this article for the following reason:",
		reasonIntroMultiple: "Powder coating is not possible for the listed articles:",
		sendToHelpdesk: "Send to helpdesk",
		close: "Close",
		messages: {
			determineError: "It was not possible to determine whether the article can be powder coated.",
		},
	},
	sendToHelpdeskDialog: {
		title: "Send article to Blexon helpdesk",
		text1:
			"You are sending this article to the Blexon helpdesk. We will check the cause of the error messages and fix it if possible. We will also be happy to give you tips on how you can modify the design so that the article becomes manufacturable.",
		freeService: "This service is free of charge.",
		text2:
			"You will be informed by e-mail as soon as the article has been processed. The review usually takes place within hours during business hours.",
		text3:
			"Please note that once sent, the article can no longer be changed or deleted until it has been approved by Blexon.",
		emailLabel: "Email for notifications regarding this article",
		sendButton: "Send",
		sendTooltip: "Sends the article to the helpdesk for clarification.",
		abortDialogTitle: "Do not send article",
		abortDialogText:
			"Do you really want to cancel this action? The article will not be forwarded to the Blexon helpdesk.",
		abortConfirmButton: "Do not send",
		abortConfirmTooltip: "Cancels the action without sending the article to the helpdesk.",
		messages: {
			sendSuccess: "The article has been sent to the helpdesk.",
			sendError: "The article could not be sent to the helpdesk. Please contact info@blexon.com.",
		},
	},
	tooManyCalculatingDialog: {
		title: "Too many calculations at the same time",
		text1: "You can blexonise up to 10 articles at the same time.",
		text2:
			"The calculations are very time- and resource-intensive. That is why we limit the number of simultaneous calculations to protect our servers and distribute performance evenly across all customers.",
		text3: "Please wait until some calculations have finished. Thank you for your understanding.",
		close: "Close",
	},
	speechBubbleFloat: {
		dontShowAgain: "Do not show this message again",
	},
};
